<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>

    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          label-width="200px"
          class="demo-ruleForm"
          :label-width="formLabelWidth"
        >
          <p>快递模版管理</p>
          <el-form-item label="菜鸟模版选择:">
            <el-select v-model="form.size" filterable placeholder="尺寸">
              <el-option
                v-for="item in sizeOps"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <p>微笑面单配置</p>
          <el-form-item label="面单信息需要加密的快递">
          <el-select
            v-model="form.smiling_sender"
            style="width: 300px"
            multiple
            filterable
          >
            <el-option
              v-for="item in sendOps"
              :key="item.value"
              :value="item.value"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>

        </el-form>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
    </el-row>
  </div>
</template>

<script>
import HeaderTabs from "../wavepicking/components/HeaderTabs";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {
        size: "0",
        smiling_sender: null
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Setting/expressSizeSetting",
      filterFold: false,
      supplyData: null,
      origin_txt: 1,
      formLabelWidth: "300px",
      sizeOps: {},
      sendOps: {}

    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.size = res.data.data.size;
          this.form.smiling_sender = res.data.data.smiling_sender;
          this.sizeOps = res.data.data.sizeOps;
          this.sendOps = res.data.data.sendOps;
        }
      });
    },
    change1($e) {
      this.onSubmit($e, 1);
    },
    submit() {
      let msg = "确认保存?";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post(this.url, this.filteredForm).then(res => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("修改成功");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/ExpressSize.vue